<template>
  <header class="header-layout">
    <div class="_container">
      <div class="_row">
        <a href="/">
          <div class="_left">
            <img
              src="/logo.svg"
              :style="{ maxWidth: '13rem' }"
            >
          </div>
        </a>
        <div class="_right">
          <slot name="right" />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderLayout',
  computed: {
    websiteUrl() {
      return import.meta.env.VITE_WEBSITE_URL;
    },
  },
};
</script>

<style
  scoped
  lang="scss"
  type="text/scss"
>
.header-layout {
  ._container {
    max-width: 1300px;
    margin: 0 auto;

    @media only screen and (max-width: 1100px) {
      padding: 0;
    }
  }

  ._row {
    padding: 1rem;
    display: flex;

    ._right {
      flex: 0 0 auto;
      margin-left: auto;
      display: flex;
      align-items: center;
    }
  }
}
</style>
